<template>
    <div class="no-hero g-px g-mb">
        <div class="row-c-nm event-form">
            <h2>{{heading}}</h2>
            <form class="form form--error-handling" enctype="multipart/form-data" @submit.prevent="submit">
                <!-- Slider main container -->
                <div class="swiper-container">
                    <!-- Additional required wrapper -->
                    <div class="swiper-wrapper">

                        <!-- Slide 1: INTRO -->
                        <div class="swiper-slide" v-if="newEntry">
                            <h3>
                                <slot name="step1-title">Intentieverklaring</slot>
                            </h3>
                            <div class="rte mb-6">
                                <slot name="step1-text">Reveil in jouw gemeente</slot>
                            </div>
                            <div class="swiper-slider__btn-row">
                                <span>Stap {{slide}}/{{totalSlides}}</span>
                                <button type="button" @click="nextSlide" class="btn btn--green">Volgende</button>
                            </div>
                        </div>

                        <!-- Slide 2: CONTACT -->
                        <div class="swiper-slide">
                            <h3>
                                <slot name="step2-title">Gegevens centrale contactpersoon</slot>
                            </h3>
                            <div class="rte mb-6">
                                <slot name="step2-text">Voor Reveil is het handig om de coördinaten te ontvangen van de spilfiguur/centrale contactpersoon van het  Reveilmoment. Als jij dat bent, mag je gewoon jouw gegevens noteren.</slot>
                            </div>
                            <div class="form-field-wrapper">
                                <div :class="{'error': fields.firstNameContact.error }" class="form-group">
                                    <label for="input-first-name-contact">Voornaam <span>*</span></label>
                                    <input id="input-first-name-contact"
                                           name="firstNameContact"
                                           type="text"
                                           v-model="fields.firstNameContact.val"
                                           @keyup="checkErrorReq(fields.firstNameContact)"
                                    >
                                    <span v-if="fields.firstNameContact.error">Gelieve een voornaam in te geven.</span>
                                </div>
                                <div :class="{'error': fields.lastNameContact.error }" class="form-group">
                                    <label for="input-last-name-contact">Familienaam <span>*</span></label>
                                    <input id="input-last-name-contact"
                                           name="lastNameContact"
                                           type="text"
                                           v-model="fields.lastNameContact.val"
                                           @keyup="checkErrorReq(fields.lastNameContact)"
                                    >
                                    <span v-if="fields.lastNameContact.error">Gelieve een familienaam in te geven.</span>
                                </div>
                            </div>
                            <div class="form-field-wrapper">
                                <div :class="{'error': fields.organisation.error }" class="form-group">
                                    <label for="input-organisation">Organisatie <span>*</span></label>
                                    <input id="input-organisation"
                                           name="organisation"
                                           type="text"
                                           v-model="fields.organisation.val"
                                           @keyup="checkErrorReq(fields.organisation)"
                                    >
                                    <span v-if="fields.organisation.error">Gelieve een organisatie in te geven.</span>
                                </div>
                            </div>
                            <div class="form-field-wrapper">
                                <div :class="{'error': fields.emailContact.error }" class="form-group">
                                    <label for="input-email-contact">E-mailadres <span>*</span></label>
                                    <input id="input-email-contact"
                                           name="emailContact"
                                           type="text"
                                           v-model="fields.emailContact.val"
                                           @keyup="checkErrorMail(fields.emailContact)"
                                    >
                                    <span v-if="fields.emailContact.error">Gelieve een correct e-mailadres in te geven.</span>
                                </div>
                                <div class="form-group">
                                    <label for="input-phone-contact">Telefoonnummer</label>
                                    <input id="input-phone-contact"
                                           name="phoneContact"
                                           type="text"
                                           v-model="fields.phoneContact.val">
                                </div>
                            </div>
                            <div class="form-field-wrapper">
                                <div :class="{'error': fields.locationCity.error }" class="form-group">
                                    <label for="input-location-city">Gemeente of stad waar je een troostactie wil brengen <span>*</span></label>
                                    <small>Typ een postcode of stad en selecteer een stad uit de lijst.</small>
                                    <v-select label="label" :clearable="false" :value="fields.locationCity.val" :options="cityOptions" id="input-location-city" @search="onSearch" @input="setLocationCity">
                                        <div slot="no-options">Selecteer een gemeente of stad</div>
                                    </v-select>
                                    <span v-if="fields.locationCity.error">Gelieve een gemeente of stad te selecteren.</span>
                                </div>
                            </div>
                            <div class="swiper-slider__btn-row">
                                <span>Stap {{slide}}/{{totalSlides}}</span>
                                <div>
                                    <button type="button" @click="prevSlide" class="btn btn--rose" v-if="newEntry">Terug</button>
                                    <button type="button" @click="nextSlide" class="btn btn--green">Volgende</button>
                                </div>
                            </div>
                        </div>

                        <!-- Slide 3: TROOSTACTIE -->
                        <div class="swiper-slide">
                            <h3>
                                <slot name="step3-title">Troostactie</slot>
                            </h3>
                            <div class="rte mb-6">
                                <slot name="step3-text"></slot>
                            </div>
                            <div class="form-group">
                                <label>Omschrijf jouw troostactie</label>
                                <p class="mb-0">
                                    Hoe ziet jouw actie er uit?<br>
                                    Pas op: jouw info verschijnt onbewerkt op de website.
                                </p>
                                <small>ENTER = nieuwe paragraaf, SHIFT+ENTER = nieuwe regel</small>
                                <ckeditor :editor="editor" v-model="fields.contentBlock.val" :config="editorConfig"></ckeditor>
                            </div>
                            <div class="form-field-wrapper">
                                <div class="form-group">
                                    <label>Foto</label>
                                    <file-upload :folder-id="asset.folderId" :field-id="asset.fieldId" :element-id="asset.elementId" :original-name="asset.originalName" :url="asset.url" @uploadComplete="onUploadComplete"></file-upload>
                                </div>
                                <div class="form-group">
                                    <label>Links</label>
                                    <p class="mb-0">Links naar jouw website of Facebook-event, ...</p>
                                    <small>Vergeet <em>http://</em> niet!</small>
                                    <table class="w-full">
                                        <tbody>
                                        <tr v-for="(row, index) in fields.externalLinks.val" :key="index">
                                            <td>
                                                <input type="text" v-model="row.link" placeholder="http://">
                                            </td>
                                            <td class="text-right w-10">
                                                <button v-if="index>0" class="btn btn--rose" type="button" @click="deleteRow(fields.externalLinks.val, row)">Wis</button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <button type="button" class="btn btn--rose mt-1" @click="addRow(fields.externalLinks.val, {link: ''})">+ Voeg een link toe</button>
                                </div>
                            </div>
                            <div class="swiper-slider__btn-row">
                                <span>Stap {{slide}}/{{totalSlides}}</span>
                                <div>
                                    <button type="button" @click="prevSlide" class="btn btn--rose">Terug</button>
                                    <button type="button" @click="nextSlide" class="btn btn--green" v-if="newEntry">Volgende</button>
                                    <button type="submit" class="btn btn--green" v-if="!newEntry">Verzenden</button>
                                </div>
                            </div>
                        </div>

                        <!-- Slide 4: VRAGEN -->
                        <div class="swiper-slide" v-if="newEntry">
                            <h3>
                                <slot name="step4-title">Nog vragen of onduidelijkheden?</slot>
                            </h3>
                            <div class="rte mb-6">
                                <slot name="step4-text">
                                    <p>Aarzel niet om <a href="/contact">ons te contacteren</a> of hieronder jouw specifieke vraag neer te schrijven.<br>We kijken alvast heel erg uit naar jullie aanpak.</p>
                                </slot>
                            </div>
                            <div class="form-group">
                                <label for="input-remarks">Jouw vragen of opmerkingen</label>
                                <textarea id="input-remarks" name="remarks" rows="8" v-model="fields.remarks.val"></textarea>
                            </div>
                            <div class="swiper-slider__btn-row">
                                <span>Stap {{slide}}/{{totalSlides}}</span>
                                <div>
                                    <button type="button" @click="prevSlide" class="btn btn--rose">Terug</button>
                                    <button type="submit" class="btn btn--green" :disabled="this.disableSubmit">
                                        <span v-show="!this.disableSubmit">Verzenden</span>
                                        <span v-show="this.disableSubmit">Even geduld</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Slide 5: SENT -->
                        <div class="swiper-slide">
                            <h3>
                                <slot name="step5-title">Troostactie geregistreerd</slot>
                            </h3>
                            <div class="rte mb-6">
                                <slot name="step5-text">
                                    <p>Bedankt!</p>
                                </slot>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Swiper from 'swiper'
import vSelect from 'vue-select'
import CKEditor from '@ckeditor/ckeditor5-vue'
import CKEditorStyle from '@ckeditor/ckeditor5-build-classic'
import FileUpload from './components/FileUpload.vue'
import VueSmoothScroll from 'vue2-smooth-scroll'
import debounce from 'debounce'

window.axios = axios

export default {
    props: {
        entryId: Number,
        user: Object
    },
    components: {
        ckeditor: CKEditor.component,
        vSelect,
        FileUpload,
        VueSmoothScroll
    },
    data() {
        return {
            editor: CKEditorStyle,
            editorConfig: {
                toolbar: ['bold','italic','|','numberedlist','bulletedlist','|','link','|','undo','redo']
            },
            slide: 1,
            totalSlides: 4,
            disableSubmit: false,
            heading: 'Troostactie registreren',
            cityOptions: [],
            newEntry: true,
            asset: {
                folderId: 10, // evenementen
                fieldId: 107, // field Image
                elementId: null,
                originalName: null,
                url: null
            },
            fields: {
                entryId: {
                    val: false,
                    error: false
                },
                title: {
                    val: '',
                    error: false
                },
                dateStart: {
                    val: '',
                    error: false
                },
                timeStart: {
                    val: '',
                    error: false
                },
                firstNameContact: {
                    val: '',
                    error: false
                },
                lastNameContact: {
                    val: '',
                    error: false
                },
                organisation: {
                    val: '',
                    error: false
                },
                emailContact: {
                    val: '',
                    error: false
                },
                phoneContact: {
                    val: '',
                    error: false
                },
                city: {
                    val: null,
                    error: false
                },
                locationCity: {
                    val: null,
                    error: false
                },
                contentBlock: {
                    val: '',
                    error: false
                },
                image: {
                    val: '',
                    error: false
                },
                externalLinks: {
                    val: [{
                        link: ''
                    }],
                    error: false
                },
                remarks: {
                    val: '',
                    error: false
                }
            }
        }
    },
    methods: {
        nextSlide() {
            this.setLocalStorage()
            switch (this.slide) {
                case 2:
                    const firstNameContact = !this.checkRequired(this.fields.firstNameContact);
                    const lastNameContact = !this.checkRequired(this.fields.lastNameContact);
                    const organisation = !this.checkRequired(this.fields.organisation);
                    const emailContact = !this.checkEmail(this.fields.emailContact);
                    const locationCity = !this.checkCity(this.fields.locationCity);

                    if (firstNameContact && lastNameContact && organisation && emailContact && locationCity) {
                        this.slide += 1;
                        this.swiper.slideNext();
                    }
                    break;

                default:
                    this.slide += 1;
                    this.swiper.slideNext();
            }

            this.$smoothScroll({
                scrollTo: document.getElementById("app"),
                updateHistory: false
            })
        },
        prevSlide() {
            this.setLocalStorage()
            this.slide -= 1
            this.swiper.slidePrev()
            this.$smoothScroll({
                scrollTo: document.getElementById("app"),
                updateHistory: false
            })
        },
        setLocalStorage() {
            localStorage.setItem('fieldsAction', JSON.stringify(this.fields));
        },
        getLocalStorage() {
            if(localStorage.getItem('fieldsAction') !== null) {
                this.fields = JSON.parse(localStorage.getItem('fieldsAction'))
            }
        },
        checkRequired(field) {
            const bool = field.val === ''
            field.error = bool
            return bool
        },
        checkEmail(field) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const bool = re.test(String(field.val).toLowerCase())
            field.error = !bool
            return !bool
        },
        checkPhone(field) {
            const phoneNumber = field.val.split(" ").join("")
            const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
            const bool = re.test(phoneNumber)
            field.error = !bool
            return !bool
        },
        checkCheckboxes(field) {
            const bool = field.val === null
            field.error = bool
            return bool
        },
        checkDropdowns(field) {
            const bool = field.val === ''
            field.error = bool
            return bool
        },
        checkCity(field) {
            const bool = field.val === null
            field.error = bool
            return bool
        },
        checkErrorReq(field) {
            if (field.val !== '') field.error = false
        },
        checkErrorMail(field) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            const bool = re.test(String(field.val).toLowerCase())
            if (bool) field.error = false
        },
        checkErrorPhone(field) {
            const phoneNumber = field.val.split(" ").join("")
            const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
            const bool = re.test(phoneNumber)
            if (bool) field.error = false
        },
        checkErrorChk(field) {
            const bool = field.val !== null
            if (bool) field.error = false
        },
        checkErrorDropdown(field) {
            const bool = field.val !== ''
            if (bool) field.error = false
        },
        setLocationCity(val) {
            if(!val.hasOwnProperty('label')) {
                val = null;
            }
            this.fields.city.val = val
            this.fields.locationCity.val = val
            // location name
            // this.fields.locationName.val = val !== null ? "Begraafplaats " + val.city : ''
            // this.fields.locationName.error = false
            // validation
            const bool = val !== null
            if (bool) this.fields.locationCity.error = false
        },
        setCity(val) {
            if(!val.hasOwnProperty('label')) {
                val = null;
            }
            this.fields.city.val = val
            // validation
            const bool = val !== null
            if (bool) this.fields.city.error = false
        },
        onSearch: debounce(
            function(search, loading) {
                if(search.length >= 2) {
                    loading(true);
                    this.search(loading, search, this);
                }
            },
            300
        ),
        search(loading, search, vm) {
            fetch(
                `/actions/reveil-module/cities/options?q=${escape(search)}`
            ).then(res => {
                res.json().then(json => (vm.cityOptions = json));
                loading(false);
            });
        },
        addRow(rows, row) {
            rows.push(row)
        },
        deleteRow(rows, row) {
            var i = rows.indexOf(row)
            if (i > -1) {
                rows.splice(i, 1)
            }
        },
        onUploadComplete(args) {
            this.fields.image.val = args.assetId
        },
        getEntry(entryId) {
            window.axios.get('/api/actions/'+entryId+'.json')
                .then(response => {
                    if(response.data) {
                        this.fields.entryId.val = response.data.entryId
                        this.fields.title.val = response.data.title
                        this.fields.firstNameContact.val = response.data.firstNameContact
                        this.fields.lastNameContact.val = response.data.lastNameContact
                        this.fields.organisation.val = response.data.organisation
                        this.fields.emailContact.val = response.data.emailContact
                        this.fields.phoneContact.val = response.data.phoneContact
                        this.fields.city.val = response.data.city
                        if(response.data.locationCity !== null)
                            this.fields.locationCity.val = response.data.locationCity
                        this.fields.contentBlock.val = response.data.contentBlock
                        if(response.data.image !== null) {
                            this.fields.image.val = response.data.image.assetId
                            this.asset.originalName = response.data.image.filename
                            this.asset.url = response.data.image.url
                        }
                        if(response.data.externalLinks !== null)
                            this.fields.externalLinks.val = response.data.externalLinks
                        this.fields.remarks.val = response.data.remarks
                        this.assets.elementId = response.data.entryId
                    }
                })
                .catch(error => console.log(error))
        },
        submit () {

            this.disableSubmit = true

            var action = '/actions/reveil-module/actions/save-entry'
            var csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
            var formData = new FormData()

            formData.set('CRAFT_CSRF_TOKEN', csrfToken)
            formData.set('entryId', this.fields.entryId.val)
            formData.set('firstNameContact', this.fields.firstNameContact.val)
            formData.set('lastNameContact', this.fields.lastNameContact.val)
            formData.set('organisation', this.fields.organisation.val)
            formData.set('emailContact', this.fields.emailContact.val)
            formData.set('phoneContact', this.fields.phoneContact.val)
            formData.set('city', JSON.stringify(this.fields.city.val))
            formData.set('locationCity', JSON.stringify(this.fields.locationCity.val))
            formData.set('contentBlock', this.fields.contentBlock.val)
            formData.set('image', this.fields.image.val)
            formData.set('externalLinks', JSON.stringify(this.fields.externalLinks.val))
            formData.set('remarks', this.fields.remarks.val)

            window.axios({
                method: 'post',
                headers: {
                    "Content-Type": 'application/x-www-form-urlencoded',
                },
                data: formData,
                url: action
            }).then((response) => {
                if(response.data.success == true) {
                    this.fields.entryId = response.data.entryId
                    if(this.newEntry) {
                        this.nextSlide()
                        localStorage.removeItem('fieldsAction')
                    }else{
                        localStorage.removeItem('fieldsAction')
                        window.location.href = "/account"
                    }
                }else{
                    this.disableSubmit = false
                    alert('Verzenden mislukt. Gelieve het formulier na te zien.')
                }
            }).catch((error) => {
                this.disableSubmit = false
                alert('Verzenden mislukt. Gelieve opnieuw te proberen.')
                console.log(error)
            })
        }
    },
    mounted() {
        this.swiper = new Swiper('.swiper-container', {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 60,
            simulateTouch: false,
            autoHeight: false,
        })
    },
    created() {
        if(this.entryId !== undefined) {
            this.heading = 'Troostactie aanpassen'
            this.newEntry = false
            this.totalSlides = 2
            this.slide = 2
            this.getEntry(this.entryId)
        }else{
            this.getLocalStorage()
        }
        if(this.user !== undefined) {
            if(this.user.firstName !== undefined && this.fields.firstNameContact.val == '') {
                this.fields.firstNameContact.val = this.user.firstName
            }
            if(this.user.lastName !== undefined && this.fields.lastNameContact.val == '') {
                this.fields.lastNameContact.val = this.user.lastName
            }
            if(this.user.email !== undefined && this.fields.emailContact.val == '') {
                this.fields.emailContact.val = this.user.email
            }
        }
    }
}
</script>

<style>
.swiper-slide {
    padding-bottom: 40px;
}
.ck.ck-button .ck.ck-tooltip {
    display: none;
}
.ck.ck-content p+p {
    @apply mt-4;
}
.ck.ck-content {
    min-height: 260px;
}
.vs__search {
    padding: 0;
}
</style>